var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowprodIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fleet-alert-settings",
    transform: "translate(-1186.000000, -193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1186.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71843687,0 0,6.71843687 0,15 C0,23.2815631 6.71843687,30 15,30 C23.2815631,30 30,23.2815631 30,15 C30,6.71843687 23.2815631,0 15,0 Z M14.2184369,27.0240481 L14.2184369,17.6152305 L8.98797595,17.6152305 L16.503006,2.9759519 L16.503006,12.3847695 L21.5380762,12.3847695 L14.2184369,27.0240481 Z",
    id: "Shape-Copy",
    fill: "#00142D",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowprodIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lowprod_icon.b611d1e015e95bc08369ed4f4d873a89.svg";